import { Button, Color, Radius, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { usePermissions } from '@dms/hook'
import { AccessType } from 'zens-store'
import { Link } from 'zens-router'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
    padding: Spacing.XXL,
    alignItems: 'center',
  },
  text: {
    textAlign: 'center',
    marginBottom: Spacing.M,
  },
  block: {
    marginTop: Spacing.M,
  },
})

interface Props {
  companyId: number
  locationId: number
  buildingId: number
}

const FloorEmpty = (props: Props) => {
  const { companyId, locationId, buildingId } = props
  const { t } = useTranslation()
  const { hasPermission } = usePermissions(companyId)

  return (
    <View style={styles.container}>
      <Text level={2} style={styles.text}>
        <Trans>There's nothing here yet</Trans>
      </Text>
      {hasPermission(AccessType.Create, 'floor') ? (
        <>
          <Text style={[styles.text, styles.block]}>
            <Trans>Add floors to specify your location and manage your floorplans.</Trans>
          </Text>
          <Link href={`/companies/${companyId}/locations/${locationId}/buildings/${buildingId}/floors/add`} asChild>
            <Button style={styles.block} title={t('Add floor')} left="plus" round testID="FloorEmpty.Add" />
          </Link>
        </>
      ) : (
        <Text style={[styles.text, styles.block]}>
          <Trans>When a floor is added it will be listed here.</Trans>
        </Text>
      )}
    </View>
  )
}

export default FloorEmpty
